import { Dispatch, SetStateAction } from 'react';
import { OnlyInDesktop, OnlyInTabletMobile } from '@components/shared';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import IconButton from '@components/shared/IconButton';
import cs from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './TourbookIconButton.module.less';

type TourbookIconButtonProps = {
  isInTourbook: boolean;
  setTourbookDialogIsOpen: Dispatch<SetStateAction<boolean>>;
  className?: string;
  showButtonTitle?: boolean;
  toolTipPlacement?: TooltipPlacement;
};

const TourbookIconButton = ({
  isInTourbook,
  setTourbookDialogIsOpen,
  className,
  showButtonTitle = true,
  toolTipPlacement = 'rightTop',
}: TourbookIconButtonProps) => {
  const { t } = useTranslation('tourbook');

  const button = (
    <IconButton
      className={cs({ [s.filled]: isInTourbook, [s.tourbookIcon]: true }, className)}
      data-testid="tourbook-button"
      icon={isInTourbook ? 'tourbook-filled' : 'tourbook'}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        setTourbookDialogIsOpen(true);
      }}
      title={showButtonTitle ? t('manageDialogs.addToTourbook') : undefined}
    />
  );

  return (
    <>
      <OnlyInDesktop>
        <Tooltip
          trigger="hover"
          placement={toolTipPlacement}
          title={t('manageDialogs.addToTourbook')}
        >
          <div>{button}</div>
        </Tooltip>
      </OnlyInDesktop>
      <OnlyInTabletMobile>{button}</OnlyInTabletMobile>
    </>
  );
};

export default TourbookIconButton;
